import { NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel } from '../../utilitymodels/base.model';

export class ThankYouModel extends BaseDataModel {
    tarnsactitionType: string;
    investorName: string;
    investorPan: string;
    folioNmuber: string;
    mobileNumber: string;
    email: string;
    totalInvestment: string;
    referenceNumber: string;
    requestDate: string;
    InvestmentType: string;
}

export class ThankYouMetaModel extends FormMetaModel {
    constructor() {
        super('Transaction ThankYou', NavigateRoutes.distributordashboard, false, NavigateRoutes.distributordashboard);
    }

    initProperties() {
        return {};
    }
}

export class ThnkYouRouteModel {
    transactionDetails: any = null;
    transactionReferenceNumber: string = '';
    totalInvestment: string = '';
    userType: string = '';
}
